import React from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import NavPage from "./NavPage";
import OrderTemplatePage from "../pages/ASOTemplate/OrderTemplate";
import { useTypedSelector } from "../hooks/useTypedSelector";
import { Box  } from "@mui/material";
import Footer from "./Footer";
import SideBarASO from "./SideBarASO";

const MainPage = () => {
    const isASO = useTypedSelector((state) => state.appSlice.isASO);
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#fff",
            }}
        >
            <Header />
            {isASO ? (
                // ASO Flow: render only OrderTemplate
                <Box sx={{ display: "flex" }}>
                    {/* Sidebar */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "18%", xl: "15%" },
                            flexBasis: { md: "20%", xl: "15%" },
                            flexShrink: 0,
                            position: { md: "fixed", xs: "relative" },
                            left: 0,
                            top: 60,
                            height: { md: "calc(100vh - 60px)", xs: "auto" },
                            borderRight: "1px solid #e0e0e0",
                            zIndex: 1100,
                        }}
                    >
                        <SideBarASO />
                    </Box>
                    {/* Main Content */}
                    <Box
                        component="main"
                        sx={{
                            width: { xs: "100%", md: "80%" },
                            flexBasis: { md: "80%" },
                            flexGrow: 1,
                            overflow: "auto",
                            ml: { md: "18%", xl: "15%" },
                            px: 1.5,
                            py: 1,
                            mb: '2rem'
                        }}
                    >
                        <OrderTemplatePage />
                    </Box>
                </Box>
            ) : (
                <Box sx={{ display: "flex" }}>
                    {/* Sidebar */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "18%", xl: "15%" },
                            flexBasis: { md: "20%", xl: "15%" },
                            flexShrink: 0,
                            position: { md: "fixed", xs: "relative" },
                            left: 0,
                            top: 60,
                            height: { md: "calc(100vh - 60px)", xs: "auto" },
                            borderRight: "1px solid #e0e0e0",
                            zIndex: 1100,
                        }}
                    >
                        <SideBar />
                    </Box>
                    {/* Main Content */}
                    <Box
                        component="main"
                        sx={{
                            width: { xs: "100%", md: "80%" },
                            flexBasis: { md: "80%" },
                            flexGrow: 1,
                            overflow: "auto",
                            ml: { md: "18%", xl: "15%" },
                            px: 1.5,
                            py: 1,
                            mb: '2rem'
                        }}
                    >
                        <NavPage />
                    </Box>
                </Box>
            )}
            <Box sx={{ 
                mx: 'auto',
                width: { xs: "100%", md: "calc(100% - 18%)", xl: "calc(100% - 15%)" }
            }}>
                <Footer />
            </Box>
        </Box>
    );
};

export default MainPage;